<vb-dropdown-menu *ngIf="showMenu" [buttonTitle]="'Video_Settings_Title' | translate" [alignMenu]="'right'" [icon]="'cogwheel'">

	<ol [ngClass]="menuItemStyles.menuOrderedList" role="menu">

		<li *ngIf="showSettings" [ngClass]="menuItemStyles.menuListItem" role="menuitem">
			<a uiSref="portal.video-settings" [uiParams]="{videoId: videoId}">
				<span class="glyphicons cogwheel theme-accent-link"></span>
				{{ 'Details' | translate }}
			</a>
		</li>

		<li *ngIf="showPreposition" [ngClass]="menuItemStyles.menuListItem" role="menuitem">
			<a (click)="VideoPlaybackComponent.isPrepositionOpen = true">
				<span class="glyphicons history theme-accent-link"></span>
				{{ 'Media_Videos_Preposition_TabTitle' | translate }}
			</a>
		</li>

		<li *ngIf="showEditVideo" class="sm-hide" [ngClass]="menuItemStyles.menuListItem" role="menuitem">
			<a uiSref="portal.edit-video" [uiParams]="{videoId: videoId}">
				<span class="glyphicons pencil theme-accent-link"></span>
				{{ 'Video_Settings_Edit' | translate }}
			</a>
		</li>

		<li *ngIf="showReplaceVideo" [ngClass]="menuItemStyles.menuListItem" role="menuitem">
			<a (click)="VideoPlaybackComponent.isReplaceVideoOpen = true">
				<span class="glyphicons roundabout theme-accent-link"></span>
				{{ 'Media_Videos_ReplaceVideo' | translate }}
			</a>
		</li>

		<li *ngIf="showApplyLegalHold" [ngClass]="menuItemStyles.menuListItem" role="menuitem">
			<a (click)="applyLegalHold()">
				<span class="glyphicons lock theme-accent-link"></span>
				{{ 'Video_LegalHold_Apply' | translate }}
			</a>
		</li>

		<li *ngIf="showRemoveLegalHold" [ngClass]="menuItemStyles.menuListItem" role="menuitem">
			<a (click)="removeLegalHold()">
				<span class="glyphicons unlock theme-accent-link"></span>
				{{ 'Video_LegalHold_Remove' | translate }}
			</a>
		</li>

		<li *ngIf="showDeleteVideo" [ngClass]="menuItemStyles.menuListItem" role="menuitem">
			<a (click)="delete()">
				<span class="glyphicons bin theme-accent-link"></span>
				{{ 'Media_Videos_Playback_Delete' | translate }}
			</a>
		</li>

	</ol>
</vb-dropdown-menu>
